export default __webpack_public_path__ + "images/b27bdaa25738ecf567ca58716df5356e-do_6.png";